import Stripe from "stripe";

export function formatSubscriptionPrice(
  amount: number,
  currency: string,
  interval?: string,
  discount?: Stripe.Discount | null,
) {
  const numberFormat = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });

  const formattedAmount = numberFormat.format(amount / 100);

  if (!interval) {
    return { amount: formattedAmount, interval: null };
  }

  const intervalText =
    interval === "month" ? ("month" as const) : ("year" as const);

  if (!discount) {
    return {
      amount: formattedAmount,
      interval: intervalText,
      discount: undefined,
    };
  }

  if (discount.coupon.amount_off) {
    const discountAmount = numberFormat.format(
      discount.coupon.amount_off / 100,
    );

    return {
      amount: formattedAmount,
      interval: intervalText,
      discount: {
        type: "amount" as const,
        amount: discountAmount,
        duration: discount.coupon.duration,
      },
    };
  }

  if (discount.coupon.percent_off) {
    const discountPercent = discount.coupon.percent_off;
    return {
      amount: formattedAmount,
      interval: intervalText,
      discount: {
        type: "percent" as const,
        percent: discountPercent,
        duration: discount.coupon.duration,
      },
    };
  }

  throw new Error(
    "Invalid discount format: must have either amount_off or percent_off",
  );
}

export function formatSubscriptionTimestamp(
  timestamp: number,
  format: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  },
) {
  const date = new Date(timestamp * 1000);
  return date.toLocaleDateString();
}
